import {
    isPwaInstallAvailable,
    isPwaInstallButtonAvailable,
    notifyGameFlash,
} from '../pwaInstallUtils';

const INSTALL_BUTTON_SELECTOR = '[data-js=pwaInstall]';
const GIFT_ICON_SELECTOR = '[data-js=pwaInstallGiftIcon]';
const ARROW_ID = 'scPwaInstallArrow';
const ARROW_ANIMATED_CLASS = 'pwa-install-arrow--animated';
const ARROW_AUTO_HIDE_MS = 3000;

let arrowResizeHandler = null;
let arrowAutoHideTimeoutId = null;
let promoEntryVisible = false;

function getArrowElement() {
    let arrow = document.getElementById(ARROW_ID);
    if (arrow != null) {
        return arrow;
    }

    arrow = document.createElement('div');
    arrow.id = ARROW_ID;
    arrow.className = 'pwa-install-arrow position-fixed d-none';
    arrow.setAttribute('aria-hidden', 'true');

    const image = document.createElement('img');
    image.alt = '';
    image.src = window.__scPwaArrowSrc || '/portal/build/images/push_arrow.png';
    arrow.appendChild(image);

    document.body.appendChild(arrow);

    return arrow;
}

function clearArrowAutoHideTimeout() {
    if (arrowAutoHideTimeoutId == null) {
        return;
    }

    clearTimeout(arrowAutoHideTimeoutId);
    arrowAutoHideTimeoutId = null;
}

function setArrowAnimated(animated) {
    const arrow = document.getElementById(ARROW_ID);
    if (arrow == null) {
        return;
    }

    arrow.classList.toggle(ARROW_ANIMATED_CLASS, animated);
}

function positionArrowAtInstallButton() {
    const button = document.querySelector(INSTALL_BUTTON_SELECTOR);
    const arrow = getArrowElement();

    if (button == null || button.classList.contains('d-none')) {
        arrow.classList.add('d-none');
        return;
    }

    const rect = button.getBoundingClientRect();
    const arrowImage = arrow.querySelector('img');
    const arrowHeight = arrowImage != null ? arrowImage.offsetHeight || 64 : 64;
    const arrowWidth = arrowImage != null ? arrowImage.offsetWidth || 64 : 64;

    arrow.style.top = `${Math.max(8, rect.bottom + 8)}px`;
    arrow.style.left = `${Math.max(8, rect.left + rect.width / 2 - arrowWidth / 2)}px`;
    arrow.classList.remove('d-none');
}

function bindArrowReposition() {
    if (arrowResizeHandler != null) {
        return;
    }

    arrowResizeHandler = () => {
        positionArrowAtInstallButton();
    };

    window.addEventListener('resize', arrowResizeHandler);
    window.addEventListener('scroll', arrowResizeHandler, true);
}

function unbindArrowReposition() {
    if (arrowResizeHandler == null) {
        return;
    }

    window.removeEventListener('resize', arrowResizeHandler);
    window.removeEventListener('scroll', arrowResizeHandler, true);
    arrowResizeHandler = null;
}

function showPersistentAnimatedInstallArrow() {
    if (!isPwaInstallAvailable()) {
        return;
    }

    getArrowElement();
    clearArrowAutoHideTimeout();
    setArrowAnimated(true);
    bindArrowReposition();
    positionArrowAtInstallButton();
}

function showInstallArrow() {
    if (!isPwaInstallAvailable()) {
        return;
    }

    getArrowElement();
    clearArrowAutoHideTimeout();
    setArrowAnimated(false);
    bindArrowReposition();
    positionArrowAtInstallButton();
}

function showTemporaryInstallArrow(durationMs = ARROW_AUTO_HIDE_MS) {
    if (!isPwaInstallAvailable()) {
        return;
    }

    getArrowElement();
    clearArrowAutoHideTimeout();
    setArrowAnimated(true);
    bindArrowReposition();
    positionArrowAtInstallButton();

    arrowAutoHideTimeoutId = setTimeout(() => {
        arrowAutoHideTimeoutId = null;
        hideInstallArrow();
    }, durationMs);
}

function hideInstallArrow() {
    clearArrowAutoHideTimeout();
    setArrowAnimated(false);

    const arrow = document.getElementById(ARROW_ID);
    if (arrow != null) {
        arrow.classList.add('d-none');
    }

    unbindArrowReposition();
}

function updatePromoEntryVisibility() {
    const giftIcon = document.querySelector(GIFT_ICON_SELECTOR);
    if (giftIcon == null) {
        return;
    }

    const shouldShow = promoEntryVisible && isPwaInstallButtonAvailable();
    giftIcon.classList.toggle('d-none', !shouldShow);
}

function setPromoEntryVisible(visible) {
    promoEntryVisible = Boolean(visible);
    updatePromoEntryVisibility();
}

window.__scPwaInstallTutorialApi = {
    isPlatformSupported: isPwaInstallButtonAvailable,
    isInstallAvailable: isPwaInstallAvailable,
    showInstallArrow,
    showPersistentAnimatedInstallArrow,
    showTemporaryInstallArrow,
    hideInstallArrow,
    setPromoEntryVisible,
    updatePromoEntryVisibility,
};

window.addEventListener('sc:installprompt', () => {
    updatePromoEntryVisibility();
    notifyGameFlash('onPwaInstallPromptAvailable');
});

window.addEventListener('appinstalled', () => {
    hideInstallArrow();
    updatePromoEntryVisibility();
    notifyGameFlash('onPwaInstalled');
});

export function initPwaInstallTutorial() {
    updatePromoEntryVisibility();
}
